export default __webpack_public_path__ + "assets/thunderstorms-day.448033cc.svg";